module.exports = __webpack_public_path__ + "img/Badge_BLONDZ.5fa6c3f8.png";